import { Dialog, Transition } from "@headlessui/react";
import { useEffect, Fragment, useState } from "react";
import { Form, Formik } from "formik";
import { apiCall, METHOD } from "../../../../service/baseApiCall";
import { REDEEMED } from "../../../../service/apiEndPoints";
import Tizen from "../../../../assets/icons/galaxy_store_2.png";
import activeTizen from "../../../../assets/icons/galaxy_store_1.png";
import activeWear from "../../../../assets/icons/goggleplay_1.png";
import Timeflik from "../../../../assets/icons/timeflik.png";
import Copy from "../../../../assets/icons/copy-icon.png";
import { SAM_TYPES } from "../../utils/constants";
import { X } from "react-feather";
import { toast } from "react-toastify";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import GetFree from "../../../../assets/icons/IconGen/getFreeButton.png"
import NowFree from "../../../../assets/icons/IconGen/nowFreeButton.png"
import SamWatchFree from "../../../../assets/icons/IconGen/samwatchFreeButton.png"
import WatchFrameGray from "../../../../assets/icons/FloatingMenu/watchGrayFrame.png"
import WatchFrameWhite from "../../../../assets/icons/FloatingMenu/watchWhiteFrame.png"
import WatchFrameBlack from "../../../../assets/icons/FloatingMenu/watchBlackFrame.png"
import ClassicFrameGray from "../../../../assets/icons/FloatingMenu/classicGrayFrame.png"
import ClassicFrameBlack from "../../../../assets/icons/FloatingMenu/classicBlackFrame.png"
import UltraWhiteFrame from "../../../../assets/icons/FloatingMenu/ultraWhiteFrame.png"
import UltraBlackFrame from "../../../../assets/icons/FloatingMenu/ultraBlackFrame.png"
import UltraOrangeFrame from "../../../../assets/icons/FloatingMenu/ultraOrangeFrame.png"
import Watch8GeneralFrame from "../../../../assets/icons/FloatingMenu/watch8GeneralFrame.png"
import Watch8ClassicFrame from "../../../../assets/icons/FloatingMenu/watch8ClassicFrame.png"
import Watch8UltraFrame from "../../../../assets/icons/FloatingMenu/watch8UltraFrame.png"
import Watch8ClassicWhiteFrame from "../../../../assets/icons/FloatingMenu/watch8ClassicWhiteFrame.png"
import Watch8GeneralBlackFrame from "../../../../assets/icons/FloatingMenu/watch8GeneralBlackFrame.png"

import Discount from "./Discount";

import "./CouponPopup.css"

interface ICouponPopup {
  isOpen: boolean
  setIsOpen: (arg0: boolean) => void
  product: any
  selected: string
  selectedWatchFrame: string
  itemType: string
}

export default function CouponPopup(props: ICouponPopup) {
  const [loading, setLoading] = useState(false);
  const [couponModal, setCouponModal] = useState(false);
  const [failModal, setFailModal] = useState(false);
  const [images, setImages] = useState([]);
  const [coupon, setCoupon] = useState("");
  const [os, setOs] = useState<string[]>([""]);
  const [selectedType, setSelectedType] = useState(
    props?.selected === SAM_TYPES.ALL
      ? props?.product?.os?.includes(SAM_TYPES.WEAR)
        ? SAM_TYPES.WEAR
        : SAM_TYPES.TIZEN
      : props?.selected
  );

  // 캐로젤 상세 모달 이미지 표시 영역
  const handleWatchFrame = () => {
    switch (props.selectedWatchFrame) {
      case "watch8General": return Watch8GeneralFrame
      case "watchGray": return WatchFrameGray
      case "watchWhite": return WatchFrameWhite
      case "watchBlack": return WatchFrameBlack
      case "watch8Classic": return Watch8ClassicFrame
      case "classicGray": return ClassicFrameGray
      case "classicBlack": return ClassicFrameBlack
      case "watch8Ultra": return Watch8UltraFrame
      case "ultraWhite": return UltraWhiteFrame
      case "ultraOrange": return UltraOrangeFrame
      case "ultraBlack": return UltraBlackFrame
      case "watch8ClassicWhite": return Watch8ClassicWhiteFrame
      case "watch8GeneralBlack": return Watch8GeneralBlackFrame

      default: return Watch8GeneralFrame
    }
  }
  const closeCouponModal = () => {
    setCouponModal(false);
    window.location.reload();
  };

  useEffect(() => {
    setSelectedType(
      props?.selected === SAM_TYPES.ALL
        ? props?.product?.os?.includes(SAM_TYPES.WEAR)
          ? SAM_TYPES.WEAR
          : SAM_TYPES.TIZEN
        : props?.selected
    );
    if (props?.selected === SAM_TYPES.TIZEN) {
      setOs(["tizen"]);
    } else if (props?.selected === SAM_TYPES.WEAR) {
      setOs(["wear"]);
    } else {
      setOs(props?.product?.os);
    }
  }, [props?.selected, props?.product?.os]);

  useEffect(() => {
    const arr: any = [];
    if (selectedType === SAM_TYPES.TIZEN) {
      props?.product?.theme_images?.map((i: any) =>
        arr.push({ url: i.image_url, alt: i?.sku, title: "Tizen" })
      );
    } else if (selectedType === SAM_TYPES.WEAR) {
      props?.product?.wear_images?.map((i: any) =>
        arr.push({ url: i.image_url, alt: i?.sku, title: "Wear" })
      );
    } else {
      if (
        props?.product?.tizen_images &&
        props?.product?.tizen_images.length > 0
      ) {
        props?.product?.tizen_images?.map((i: any) =>
          arr.push({ url: i.image_url, alt: i?.sku, title: "Tizen" })
        );
      }
      if (
        props?.product?.wear_images &&
        props?.product?.wear_images.length > 0
      ) {
        props?.product?.wear_images?.map((i: any) =>
          arr.push({ url: i.image_url, alt: i?.sku, title: "Wear" })
        );
      }
    }
    setImages(arr);
  }, [props?.product, selectedType]);

  const setIsOpen = (e: boolean) => {
    setSelectedType(
      props?.selected === SAM_TYPES.ALL
        ? props?.product?.os?.includes(SAM_TYPES.WEAR)
          ? SAM_TYPES.WEAR
          : SAM_TYPES.TIZEN
        : props?.selected
    );
    props?.setIsOpen(e);
  };

  return (
    <>
      <Transition appear show={props?.isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={() => null}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-[0.85]" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-80 sm:w-[25rem] transform rounded-2xl overflow-hidden bg-black text-left align-middle shadow-xl justify-center transition-all">
                  <div className="relative w-full h-full">
                    <div className="w-full h-full">
                      {images?.map((item: any, idx: number) => {
                        return (
                          <div
                            className="hover:bg-none content-center relative w-full m-0 overflow-hidden"
                            key={idx}
                          >
                            <img
                              src={item?.url}
                              className=" object-contain h-80 sm:h-[25rem]"
                              alt={item?.alt}
                            />
                            <div className="absolute rotate-[320deg] overflow-hidden bottom-[10%] left-[25%] z-[2] h-[45px] w-full">
                              <Discount
                                is_discount={props.product.is_discount}
                                discount_rate={props.product.discount_rate}
                                style={
                                  {
                                    "fontSize": "30px",
                                    "height": "45px",
                                    "transform": "rotate(0deg)"
                                  }
                                }
                              />
                            </div>
                            <div className={`absolute lg:top-2 sm:top-1 top-0.5 flex flex-row gap-2`}>
                              {props.product.enable_get_coupon ?
                                <img
                                  src={GetFree}
                                  style={{ "zIndex": 2 }}
                                  alt=""
                                />
                                : props.product.enable_now_coupon ?
                                  <img
                                    src={NowFree}
                                    style={{ "zIndex": 2 }}
                                    alt=""
                                  />
                                  : props.product.enable_free_coupon ?
                                    <img
                                      src={SamWatchFree}
                                      style={{ "zIndex": 2 }}
                                      alt=""
                                    />
                                    : null
                              }
                            </div>
                            {
                              os?.includes("wear") ?
                                <img
                                  src={handleWatchFrame()}
                                  alt=""
                                  className="watchFrame"
                                  style={{ zIndex: 1, height: "100%" }}
                                />
                                : null
                            }
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div
                    onClick={() => setIsOpen(false)}
                    className=" absolute right-1.5 top-1.5 z-10"
                  >
                    <X className="text-white sm:h-8 sm:w-8 bg-[#d23434] rounded shadow-md hover:cursor-pointer" />
                  </div>
                  <Formik
                    initialValues={{
                      id: props?.product?.id,
                      sku: props?.product?.sku,
                    }}
                    onSubmit={(values) => {
                      // const URL = REDEEMED.replace(":sam_switch_id", values.id);
                      const URL = REDEEMED.replace(":sku", values.sku).replace(":type", props?.itemType)
                      apiCall(
                        URL,
                        {},
                        (res: any) => {
                          if (res?.success) {
                            setCoupon(res?.data);
                            props?.setIsOpen(false);
                            setCouponModal(true);
                            setLoading(false);
                          }
                        },
                        (err: any) => {
                          setIsOpen(false);
                          setFailModal(true);
                          setLoading(false);
                        },
                        METHOD.GET,
                        {}
                      );
                    }}
                  >
                    {({ errors }) => (
                      <Form className="p-6 bg-white">
                        <div className="flex justify-between items-center">
                          <div className="flex flex-row">
                            <img
                              className={`${os?.includes("wear") ? "" : "hidden"
                                } ${props.product?.vendor === "google" ? "h-8" : "h-14 w-auto"} mr-2`}

                              src={
                                selectedType === SAM_TYPES.WEAR
                                  ? props.product?.vendor === "timeflik" ? Timeflik : activeWear
                                  : ""
                              }
                              alt=""
                            />

                            <img
                              className={`${os?.includes("tizen") ? "" : "hidden"
                                } h-8 mr-2 rounded-full hover:cursor-pointer`}
                              onClick={() => {
                                setSelectedType(SAM_TYPES.TIZEN);
                              }}
                              onMouseOver={(e) =>
                                (e.currentTarget.src = activeTizen)
                              }
                              onMouseOut={(e) =>
                              (e.currentTarget.src =
                                selectedType === SAM_TYPES.TIZEN
                                  ? activeTizen
                                  : Tizen)
                              }
                              src={
                                selectedType === SAM_TYPES.TIZEN
                                  ? activeTizen
                                  : Tizen
                              }
                              alt=""
                            />
                          </div>
                          <div
                            className={`${!props?.product?.coupon_enabled
                              ? "hidden"
                              : "block"
                              } ml-1 inline-block py-1 px-2 text-xs h-fit text-white rounded-md bg-slate-800 shadow hover:cursor-pointer`}
                            onClick={() =>
                              window.open(
                                selectedType === SAM_TYPES.TIZEN
                                  ? props?.product?.theme_link
                                  : props?.product?.wear_link
                              )
                            }
                          >
                            Link to this Product
                          </div>
                        </div>

                        <Dialog.Title
                          as="h3"
                          className="text-lg mt-4 font-medium leading-6 text-gray-900"
                        >
                          {props?.product?.name}
                        </Dialog.Title>
                        <div className="mt-2">
                          <p
                            style={{ whiteSpace: "pre-wrap" }}
                            className="text-sm text-gray-500 min-h-[140px] max-h-[140px] sm:max-h-[240px] overflow-y-auto"
                          >
                            Description : <br />
                            {props?.product?.description}
                          </p>
                        </div>

                        <div className="mt-6 flex justify-center">
                          {props?.product?.coupon_enabled && props?.product?.enable_get_coupon ? (
                            <button
                              type="submit"
                              className="inline-flex justify-center  text-center w-3/4 rounded-md border border-transparent bg-sky-500 px-4 py-2 text-sm font-medium text-white hover:bg-sky-600 focus:outline-none"
                              onClick={() => {
                                setLoading(true);
                              }}
                            >
                              {loading ? "Loading..." : "Get a Coupon"}
                            </button>
                          ) : (
                            <button
                              type="button"
                              onClick={() => {
                                window.open(
                                  selectedType === SAM_TYPES.TIZEN
                                    ? props?.product?.theme_link
                                    : props?.product?.wear_link
                                )
                              }

                              }
                              className="inline-flex justify-center  text-center w-3/4 rounded-md border border-transparent bg-sky-500 px-4 py-2 text-sm font-medium text-white hover:bg-sky-600 focus:outline-none"
                            >
                              Link to this Product
                            </button>
                          )}
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      <Transition appear show={couponModal} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={() => null}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-[0.85]" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <div
                    onClick={() => closeCouponModal()}
                    className=" absolute right-1.5 top-1"
                  >
                    <X className="text-white sm:h-8 sm:w-8 bg-[#d23434] rounded shadow-md hover:cursor-pointer" />
                  </div>
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    Congratulations!
                  </Dialog.Title>
                  <div className="code-wrapper">
                    <CopyToClipboard text={coupon} >
                      <div onClick={() => {
                        toast('✅ \t Coupon Code Copied!', {
                          className: "rounded-lg text-center md:text-lg",
                          position: "bottom-center",
                          autoClose: 1000,
                          hideProgressBar: true,
                          closeOnClick: true,
                          draggable: true,
                        })
                      }} className="border rounded relative  flex items-center mt-6 pt-1">
                        <span
                          className="text-center text-gray-600 text-3xl w-full overflow-x-auto pb-1 px-1"
                        >
                          {coupon}
                        </span>
                        <img
                          className="h-6 mr-1 hover:cursor-pointer mb-1"
                          src={Copy}
                          alt=""
                        />
                      </div>
                    </CopyToClipboard>
                  </div>


                  <div>
                    <p className="text-xs mt-10 text-center text-red-400">
                      Please keep the coupon code. <br /> You can’t download the
                      coupon again
                    </p>
                  </div>
                  <div className="mt-6 flex justify-center">
                    <button
                      type="button"
                      className="mx-auto inline-flex justify-center  text-center w-3/4 rounded-md border border-transparent bg-sky-500 px-4 py-2 text-sm font-medium text-white hover:bg-sky-600"
                      onClick={() =>
                        window.open(
                          selectedType === SAM_TYPES.TIZEN
                            ? props?.product?.tizen_link
                            : 'http://play.google.com/redeem'
                        )
                      }
                    >
                      Go To Store
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      <Transition appear show={failModal} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => setFailModal(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-[0.85]" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    Alert
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-center text-gray-500">
                      No Coupon Available
                    </p>
                  </div>

                  <div className="mt-8 flex justify-center">
                    <button
                      type="button"
                      className="mx-auto inline-flex justify-center  text-center w-3/4 rounded-md border border-transparent bg-red-500 px-4 py-2 text-sm font-medium text-white hover:bg-red-600"
                      onClick={() => setFailModal(false)}
                    >
                      Close
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
